import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import EmployeeLogin from "@/pages/EmployeeLogin";
import AdminLogin from "@/pages/AdminLogin";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEmployees from "@/pages/AdminEmployees";
import AdminReports from "@/pages/AdminReports";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login/employee" replace />} />
          <Route path="/login/employee" element={<EmployeeLogin />} />
          <Route path="/login/admin" element={<AdminLogin />} />
          <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/employees" element={<AdminEmployees />} />
          <Route path="/admin/reports" element={<AdminReports />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;